"use strict";

exports.__esModule = true;
exports.timeValidator = exports.VALIDATOR_TYPE = void 0;
var _timeValidator = require("./timeValidator");
exports.VALIDATOR_TYPE = _timeValidator.VALIDATOR_TYPE;
exports.timeValidator = _timeValidator.timeValidator;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/timeValidator/index.js
// module id = 599
// module chunks = 0